// Farm deploy flavour, self-reported by the (host) farm agent on each ping. Client
// mirror of the server's farmType.ts — keep in sync.
//  - Regular — a normal docker farm agent.
//  - Vmos    — a VMOS (cloud-phone) deployment.
// Distinct axis from FarmKind (host vs aggregator topology).
export var FarmType;
(function (FarmType) {
    FarmType["Regular"] = "regular";
    FarmType["Vmos"] = "vmos";
})(FarmType || (FarmType = {}));
export const DEFAULT_FARM_TYPE = FarmType.Regular;
export function normalizeFarmType(value) {
    return value === FarmType.Vmos ? FarmType.Vmos : FarmType.Regular;
}
